import { defineStore } from 'pinia';

type EventPopupStoreType = {
	projectId: string | null;
	startDate: string | null;
	dueDate: string | null;
	plannedDuration: number | null;
};

/**
 * Store for Event Popup state communication between monolith and MFE
 */
export const useEventPopupStore = defineStore('eventPopup', {
	state: (): EventPopupStoreType => ({
		projectId: null,
		startDate: null,
		dueDate: null,
		plannedDuration: null,
	}),
});
